import React, {PureComponent} from 'react';
import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import TextSearch from '../../../components/TextSearch';
import * as http from '../../../modules/http';
import LoadingProgress from '../../../components/LoadingProgress';
import {
    change_sim_update_field,
    change_sim_insert, change_sim_update
} from '../../../redux/actions/ChangeSimActions';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as environment from "../../../modules/environment";
import * as TextManager from "../../../modules/languages/TextManager";
import ProvidersItems from './ProvidersItems'
import {checkId} from "../../../modules/common"
import ChatCard from '../../../components/Chat/components/ChatCard'
import moment from 'moment';


class EditChangeSimForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            providerId: 0,
            comment: ""
        };
    }

    componentDidMount() {
    }


    editValue = (label, newValue) => {
        this.props.dispatch(change_sim_update_field(label, newValue));
    };

    chooseProvider = (id, name) => {
        /*this.editValue('providerId', id);
        this.editValue('providerName', name);*/
        this.setState({providerId: id, providerName: name});
    };

    getProviderId = () => {
        if (this.state.providerId !== 0) {
            // it comes from path
            return this.state.providerId;
        }
        else if (this.props.changeSimInEdit !== 0) {
            return this.props.changeSimInEdit.providerId;
        }
        else {
            return undefined;
        }
    };

    changeLineStatus = () => {
        let newStatus = this.changeStatusStateMachine(this.props.changeSimInEdit.status);

        this.editValue('status', newStatus);
    };

    changeStatusStateMachine = (currentStatus) => {
        if(currentStatus === 2)
            return 0;
        else if(currentStatus === 0)
            return 1;
        else if(currentStatus === 1)
            return 2;
        else
            return 2;
    };

    updateComment = (value, type) => {
        this.setState({comment: value});
    };


    saveItem = () => {

        //console.log(this.props.changeSimInEdit)

        const isAdding = (this.props.changeSimInEdit.id === 0);

        if (isAdding) {
            if (!this.props.changeSimInEdit.name || this.props.changeSimInEdit.name === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }
        }

        if (!checkId(this.props.changeSimInEdit.passport)) {
            this.setState({warning: 'מספר תז לא תקין'});
            return;
        }

        let chat = this.props.changeSimInEdit.chat ? this.props.changeSimInEdit.chat : [];


        if (!isAdding) {
            http.postToServer(
                'change_sim/get_chat',
                {id: parseInt(this.props.changeSimInEdit.id)},
                (response) => {
                    chat = response.data.chat;
                },
                (response) => {
                    console.log('error get chat');
                }
            );
        }

        if (this.state.comment !== '') {
            chat.push({
                name: this.props.userData.data.name, message: this.state.comment, date: moment().format('llll'),
                isStore: (this.props.userData.data.isManager !== true && this.props.userData.data.isAdmin !== true) ? 1 : 0
            })
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            //...this.props.managerInEdit,
            id: this.props.changeSimInEdit.id,
            day: this.props.changeSimInEdit.day,
            updateDay: this.props.changeSimInEdit.updateDay,
            providerId: isAdding ? this.state.providerId : this.props.changeSimInEdit.providerId,
            providerName: isAdding ? this.state.providerName : this.props.changeSimInEdit.providerName,
            name: this.props.changeSimInEdit.name,
            passport: this.props.changeSimInEdit.passport,
            subNumber: this.props.changeSimInEdit.subNumber,
            simChange: this.props.changeSimInEdit.simChange,
            paymentNum: this.props.changeSimInEdit.paymentNum,
            storeId: isAdding? this.props.userData.data.id : this.props.changeSimInEdit.storeId,
            storeName: isAdding ? this.props.userData.data.name : this.props.changeSimInEdit.storeName,
            status: isAdding ? 0 : this.props.changeSimInEdit.status,
            chat: chat
        };

        //console.log(storeData);

        var requestUrl = 'change_sim/update';
        if (isAdding) {
            requestUrl = 'change_sim/new';
        }
        http.postToServer(
            requestUrl,
            storeData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(change_sim_insert(response.data));
                }
                else {
                    this.props.dispatch(change_sim_update(response.data));
                }

                //this.props.dispatch(fetchUserDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    };

    render() {

        const isAdding = this.props.changeSimInEdit.id === 0;

        //console.log(this.props.managerInEdit.userType)
        let text = ' ספרות א. תשלום';

        let providerId = this.getProviderId();
        let logoUrl =  "";

        if(providerId !== undefined) {
            logoUrl = environment.getServerBasePath() + '/api/providers/download?providerID=' + providerId;
        }

        let status = '';
        let color = '';

        if (this.props.changeSimInEdit.status === 0) {
            status = 'חדש';
            color = 'warning';
        } else if (this.props.changeSimInEdit.status === 1) {
            status = 'לא פעיל';
            color = 'danger';
        } else {
            status = 'פעיל';
            color = 'success';
        }

        let isChangeStatus = false;

        if (this.props.userData.data.isManager || this.props.userData.data.isAdmin) {
            isChangeStatus = true;
        }

        return (

            <Row style={{flexDirection: "row-reverse"}}>
                {isAdding && this.state.providerId === 0 && <Col md={12} lg={12}>
                    <ProvidersItems items={this.props.sales} chooseProvider={this.chooseProvider}/>
                </Col>}

                {isAdding && this.state.providerId !== 0 &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody style={{boxShadow: 'none'}}>
                                <div className='card__title'>
                                    <h5 className='bold-text'>ספק</h5>
                                </div>
                                <div>
                                    <img src={logoUrl} style={{
                                        maxWidth: '190px',
                                        maxHeight: '190px',
                                        objectFit: 'contain'
                                    }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card>
                            <CardBody>
                                <div className='card__title'>
                                    <h5 className='bold-text'>הוסף בקשה</h5>
                                </div>

                                <form className='form form--horizontal'>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>שם מלא</label>
                                        <div className='form__form-group-field'>
                                            <TextSearch value={this.props.changeSimInEdit.name}
                                                        onChange={(value) => this.editValue( 'name', value)}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>ת.ז.</label>
                                        <div className='form__form-group-field'>
                                            <TextSearch value={this.props.changeSimInEdit.passport} noSpace
                                                        onChange={(value) => this.editValue( 'passport', value)}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>מס' המנוי</label>
                                        <div className='form__form-group-field'>
                                            <TextSearch value={this.props.changeSimInEdit.subNumber} noSpace
                                                        onChange={(value) => this.editValue( 'subNumber', value)}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>מס' הסים להחלפה </label>
                                        <div className='form__form-group-field'>
                                            <TextSearch value={this.props.changeSimInEdit.simChange} noSpace
                                                        onChange={(value) => this.editValue( 'simChange', value)}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'><p>4</p>{text} </label>
                                        <div className='form__form-group-field'>
                                            <TextSearch value={this.props.changeSimInEdit.paymentNum} noSpace
                                                        onChange={(value) => this.editValue('paymentNum', value)}/>
                                        </div>
                                    </div>

                                    <div className="form__form-group" dir="rtl">
                                        <ChatCard
                                            type={1}
                                            userId={isAdding ? 0 : this.props.changeSimInEdit.id}
                                            chat={this.props.changeSimInEdit.chat}
                                            currentUser={this.props.userData.data}
                                            comment={this.state.comment}
                                            deleteMessage={this.deleteMessage}
                                            updateComment={this.updateComment}
                                            background={'lightgrey'}
                                        />
                                    </div>

                                </form>

                                {this.state.error &&
                                <Row>
                                    <Alert color='danger' className='alert--bordered' icon>Day
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                        </p>
                                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                    </Alert>
                                </Row>
                                }

                                {this.state.warning !== '' &&
                                <Row>
                                    <Alert color='warning' className='alert--bordered' icon>
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                        </p>
                                    </Alert>
                                </Row>
                                }

                                {!this.state.saving &&
                                <span>
                                <Button color='primary' size='sm'
                                        onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                <Button color='primary' size='sm'
                                        onClick={() => this.saveItem()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                            </span>
                                }
                                {
                                    this.state.saving &&
                                    <LoadingProgress/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                }

                {!isAdding &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody style={{boxShadow: 'none'}}>
                                <div className='card__title'>
                                    <h5 className='bold-text'>ספק</h5>
                                </div>
                                <div>
                                    <img src={logoUrl} style={{
                                        maxWidth: '190px',
                                        maxHeight: '190px',
                                        objectFit: 'contain'
                                    }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card>
                            <CardBody>
                                <div className='card__title'>
                                    <h5 className='bold-text'>{TextManager.getCurrentTextResource().Settings.editManager}</h5>
                                </div>

                                <form className='form form--horizontal'>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>שם מלא</label>
                                        <div className='form__form-group-field'>
                                            <input value={this.props.changeSimInEdit.name} disabled={true}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>ת.ז.</label>
                                        <div className='form__form-group-field'>
                                            <input value={this.props.changeSimInEdit.passport} disabled={true}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>מס' המנוי</label>
                                        <div className='form__form-group-field'>
                                            <input value={this.props.changeSimInEdit.subNumber} disabled={true}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>מס' הסים להחלפה </label>
                                        <div className='form__form-group-field'>
                                            <input value={this.props.changeSimInEdit.simChange} disabled={true}/>
                                        </div>
                                    </div>

                                    <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'><p>4</p>{text} </label>
                                        <div className='form__form-group-field'>
                                            <input value={this.props.changeSimInEdit.paymentNum} disabled={true}/>
                                        </div>
                                    </div>

                                    {isChangeStatus && <div className='form__form-group'>
                                        <label
                                            className='form__form-group-label'>{TextManager.getCurrentTextResource().Customers.status}
                                        </label>
                                        <div className='form__form-group-field'>
                                            <Button
                                                color={color}
                                                size='sm'
                                                style={{
                                                    marginTop: '10px',
                                                    fontSize: '12px',
                                                }}
                                                onClick={() => this.changeLineStatus()}>{status}
                                            </Button>
                                        </div>
                                    </div>}

                                    <div className="form__form-group" dir="rtl">
                                        <ChatCard
                                            type={1}
                                            userId={isAdding ? 0 : this.props.changeSimInEdit.id}
                                            chat={this.props.changeSimInEdit.chat}
                                            currentUser={this.props.userData.data}
                                            comment={this.state.comment}
                                            deleteMessage={this.deleteMessage}
                                            updateComment={this.updateComment}
                                            background={'lightgrey'}
                                        />
                                    </div>

                                </form>

                                {this.state.error &&
                                <Row>
                                    <Alert color='danger' className='alert--bordered' icon>
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                        </p>
                                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                    </Alert>
                                </Row>
                                }

                                {this.state.warning !== '' &&
                                <Row>
                                    <Alert color='warning' className='alert--bordered' icon>
                                        <p><span
                                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                        </p>
                                    </Alert>
                                </Row>
                                }

                                {!this.state.saving &&
                                <span>
                                    <Button color='primary' size='sm'
                                            onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                    <Button color='primary' size='sm'
                                             onClick={() => this.saveItem()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                </span>
                                }
                                {
                                    this.state.saving &&
                                    <LoadingProgress/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>}

            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        changeSimInEdit: state.changeSim.changeSimInEdit,
        sales: state.sales.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditChangeSimForm))